import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { setWalletAddress, getWalletAddress } from '../../wallet/wallet.action'
import { setMenu } from '../../../App.action'
import { connectMetamask } from '../../../utils/web3'
import { ENV } from '../../../config/config';
import { Link, useHistory } from "react-router-dom";
import Select from 'react-select';
import GlobalWarning from './../../../components/global-warning/global-warning';
import siteLogoDarkMode from '../../../assets/images/logo-dark-mode.svg';
import siteLogoLightMode from '../../../assets/images/logo-light-mode.svg';


const child = { height: `100%` }

const Header = (props) => {
	const [connectedAddress, setConnectedAddress] = useState('');
	const [loader, setLoader] = useState(true);
	const { _id } = ENV.getUserKeys('_id');
	const [headerCheck, setHeaderCheck] = useState(false);
	const [colorCheck, setColorCheck] = useState(false);
	const [logoutCheck, setLogoutCheck] = useState(true);

	useEffect(async () => {
		let connectedAddress = await connectMetamask();
		setConnectedAddress(connectedAddress)
		props.setWalletAddress(connectedAddress)
	}, [])

	useEffect(() => {
		let menu = localStorage.getItem("menu");
		let color = localStorage.getItem("color");
		if (menu !== null) {
			if (menu === 'true') {
				setHeaderCheck(true)
				menuSetter(true)
			}
			else {
				setHeaderCheck(false)
				menuSetter(false)
			}
		}
		if (color !== null) {
			if (color === 'true') {
				setColorCheck(true)
				colorSetter(true)
			}
			else {
				setColorCheck(false)
				colorSetter(false)
			}
		}
	}, [])

	// set loader to false when address is received
	useEffect(() => {
		if (connectedAddress)
			setLoader(false)
	}, [connectedAddress])

	const menuSetter = (check) => {
		if (check) {
			document.querySelector(`body`).classList.add('left-menu');
		}
		else {
			document.querySelector(`body`).classList.remove('left-menu');
		}
		localStorage.setItem("menu", check);
		if (pathname !== '/') {
			document.querySelector(`body`).classList.remove('left-menu');
		}
	}

	const colorSetter = (check) => {
		if (check) {
			document.querySelector(`body`).classList.add('light-mode');
		}
		else {
			document.querySelector(`body`).classList.remove('light-mode');
		}
		localStorage.setItem("color", check);
	}

	const formatAddress = (address) => {
		return address ? address.substr(0, 6) + '...' + address.substr(-4) : null;
	}

	const history = useHistory();
	const pathname = history.location.pathname;

	const [selectedOption, setSelectedOption] = useState({ value: 'chocolate', label: 'Chocolate' })
	const [deviceWidth, setDeviceWidth] = useState(0)


	const handleChange = e => {
		setSelectedOption(e)
	};
	const changeDeviceWidth = (width) => {
		setDeviceWidth(width)
	};
	useEffect(() => {
		window.addEventListener('resize', function () {
			changeDeviceWidth(window.width);
		});
	}, [])
	return (
		<>
			<header id="header" className="main-header home-header">
				{/* Header Top */}
				<div className="header-top">
					<div className="container header">
						<div className="d-flex justify-content-between align-items-center">
							<div className="d-flex flex-fill">
								<div className="logo-and-form d-flex align-items-center">
									<Link className="navbar-brand mr-0 mr-md-4" to="/">
										<img className="navbar-brand-sticky logo-dark-mode" src={siteLogoDarkMode} alt="sticky brand-logo" />
										<img className="navbar-brand-sticky logo-light-mode" src={siteLogoLightMode} alt="sticky brand-logo" />
									</Link>
									{/* <div className="search-form-holder">
										<form className="search-form position-relative">
											<input type="text" className="form-control" placeholder="Search" />
											<button type="button" className="p-0">
												<img className="icon-dark" src={searchIconDark} alt="" />
												<img className="icon-light" src={searchIconLight} alt="" />
											</button>
										</form>
									</div> */}
								</div>
								<div className="main-nav">
									<nav className="navbar navbar-expand-xl">
										<button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
											<i className="fas fa-bars"></i><span className="ml-2">Menu</span>
										</button>
										<div className="collapse navbar-collapse" id="navbarSupportedContent">
											<ul className="navbar-nav mr-auto">
												<li className={`nav-item ${pathname === '/' ? 'active' : ''}`}>
													<Link className="nav-link" to="/">Marketplace</Link>
												</li>
												<li className={`nav-item ${pathname === '/collections' ? 'active' : ''}`}>
													<Link className="nav-link" to="/collections">Collections</Link>
												</li>
												<li className={`nav-item ${pathname === '/auctions' ? 'active' : ''}`}>
													<Link className="nav-link" to="/auctions">Auctions</Link>
												</li>
												<li className={`nav-item ${pathname === '/rankings' ? 'active' : ''}`}>
													<Link className="nav-link" to="/rankings">Rankings</Link>
												</li>
												<li className={`nav-item ${pathname === '/activity' ? 'active' : ''}`}>
													<Link className="nav-link" to="/activity">Activity</Link>
												</li>
												<li className={`nav-item ${pathname === '/contact' ? 'active' : ''}`}>
													<Link className="nav-link" to="/contact">Contact</Link>
												</li>
												<li className={`nav-item ${pathname === '/create' ? 'active' : ''}`}>
													<Link className="nav-link" to="/create">Create</Link>
												</li>
											</ul>
										</div>
									</nav>
								</div>
							</div>
							<div className="d-flex align-items-center">
								{/* <span className="mobile-search-icon" data-toggle="modal" data-target="#search">
									<i className="fas fa-search"></i>
								</span> */}
								<div className="dropdown settings-dropdown">
									<button className="dropdown-toggle settings-btn d-flex justify-content-center align-items-center" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
										<i className="fas fa-cog"></i>
									</button>
									<div className="dropdown-menu settings-dropdown-menu" aria-labelledby="dropdownMenuButton">
										{pathname === '/' ? <>
											<span className="setting-heading mb-3 mb-md-5 d-block">Header Option</span>
											<div className="toggle-holder d-flex justify-content-between align-items-center mb-3 mb-md-5 pb-3 pb-md-5">
												<span className="toggle-text top-menu-text">Top Menu</span>
												<label className="toggle-switch">
													<input type="checkbox" checked={headerCheck ? `true` : ''}
														onClick={(e) => {
															props.setMenu(headerCheck ? 1 : 2)
															setHeaderCheck(!headerCheck);
															menuSetter(e.target.checked);
														}}
													/>
													<span className="slider round"></span>
												</label>
												<span className="toggle-text left-menu-text">Left Menu</span>
											</div></>
											: ''
										}
										<span className="mb-3 d-block">Color Option</span>
										<div className="d-flex radios-holder">
											<div className={`color-circle dark-mode mr-2 ${colorCheck ? `` : `active`}`} onClick={(e) => { setColorCheck(false); colorSetter(false); }} >
												<span className="circle">&nbsp;</span>
											</div>
											<div className={`color-circle light-mode mr-2 ${colorCheck ? `active` : ``}`} onClick={(e) => { setColorCheck(true); colorSetter(true); }} >
												<span className="circle">&nbsp;</span>
											</div>
										</div>
									</div>
								</div>
								{
									logoutCheck && connectedAddress && _id ?
										<div className="dropdown account-dropdown">
											<span id="wallet-address" className="btn ml-lg-auto btn-bordered-white dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i className="icon-wallet mr-1 mr-md-2" /><span className="address">{formatAddress(connectedAddress)}</span></span>

											<div className="dropdown-menu account" aria-labelledby="dropdownMenuButton">
												<ul className="navbar-nav mr-auto">
													<li className={`nav-item ${pathname === '/profile' ? 'active' : ''}`}>
														<Link className="nav-link" to="/profile">My Profile</Link>
													</li>
													<li className={`nav-item ${pathname === '/create' ? 'active' : ''}`}>
														<Link className="nav-link" to="/create">Create</Link>
													</li>
													<li className={`nav-item ${pathname === '/my-collections' ? 'active' : ''}`}>
														<Link className="nav-link" to="/my-collections">My Collections</Link>
													</li>
													<li className={`nav-item`}>
														<Link className="nav-link"
															to="/"
															onClick={() => {
																localStorage.removeItem("encuse");
																localStorage.removeItem("connectedAddress");
																setLogoutCheck(false);
															}} >
															Logout
														</Link>
													</li>
												</ul>
											</div>
										</div>
										:
										<div className="dropdown account-dropdown">
											<Link to="/login" className="btn btn-bordered-white btn-connect-wallet">
												<i className="icon-wallet mr-lg-2 d-block d-lg-none" />
												<span className="d-none d-lg-block">Connect Wallet</span>
											</Link>
										</div>
								}
							</div>
						</div>
					</div>
				</div>
			</header>
			{
				props.wallet && props.wallet.walletError ?
					<GlobalWarning message={props.wallet.walletError} /> : ''
			}
		</>
	);
};

const mapStateToProps = state => ({
	wallet: state.wallet,
});

export default connect(mapStateToProps, { setWalletAddress, getWalletAddress, setMenu })(Header);